<template>
  <section id="home">
    <main>
      <div class="menu">
        <div class="ico-container">
          <template v-for="(item, index) in menuItems">
            <div
              :key="index"
              v-if="item.canSee"
              class="menu-item"
              @click="navigate(item)"
            >
              <span class="wrapper">
                <icon icoClass='menu-ico' :selected='item.ico' display='table-row' />
                <div
                  class="menu-name"
                  :style="item.smallFont ? 'font-size:0.8em !important;' : ''"
                >
                  {{ $t(item.label) }}
                </div>
              </span>
            </div>
          </template>

          <div v-if="!permissionsLoaded" style="margin-top:20px; color: grey;">
            Loading permissions...
          </div>

        </div>
      </div>
    </main>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import icon from './../svg/tabs'

export default {
  name: 'home',
  components: { icon },
  data () {
    return {
      companyCode: process.env.COMPANY,
      permissionsLoaded: false,
      menuItems: [
        {
          label: 'trucks',
          ico: 'trucks',
          path: '/trucks',
          clean: true,
          permission: 'seeTrucks',
          canSee: false
        },
        {
          label: 'expeditions',
          ico: 'expeditions',
          path: '/expeditions',
          clean: true,
          permission: 'seeExpeditions',
          canSee: false
        },
        {
          label: 'receptions',
          ico: 'receptions',
          path: '/receptions',
          clean: true,
          permission: 'seeReceptions',
          canSee: false
        },
        {
          label: 'critical_lines',
          ico: 'criticalLines',
          path: '/critical-lines',
          clean: true,
          permission: 'seeCriticalLines',
          smallFont: true,
          canSee: false
        },
        {
          label: 'tasks',
          ico: 'tasklist',
          path: '/task-list',
          clean: true,
          permission: 'seeTasklist',
          smallFont: true,
          canSee: false
        },
        {
          label: 'bi',
          ico: 'bi',
          path: '/bi',
          clean: false,
          permission: 'seeBi',
          canSee: false
        }
      ]
    }
  },
  created () {
    this.$emit('loading')
  },
  mounted () {
    this.checkPermissionsAndCompany()
  },
  computed: {
    ...mapState({
      auth: state => state.auth
    })
  },
  methods: {
    ...mapActions({
      checkPermissions: 'auth/checkPermissions'
    }),

    navigate (item) {
      const routeQuery = item.clean ? { clean: 'true' } : {}
      this.$router.push({ path: item.path, query: routeQuery })
    },

    async checkPermissionsAndCompany () {
      try {
        const permissionsToAsk = this.menuItems.map(item => item.permission)
        const response = await this.checkPermissions(permissionsToAsk)

        this.menuItems.forEach(item => {
          if (response && response[item.permission] !== undefined) {
            item.canSee = response[item.permission]
            if (item.label === 'critical_lines') {
              item.canSee = this.auth.hasCriticalLines && response[item.permission]
            } else if (item.label === 'tasks') {
              item.canSee = this.auth.hasTasks && response[item.permission]
            } else {
              item.canSee = response[item.permission]
            }
          } else {
            item.canSee = false
            console.warn(`Permission ${item.permission} not found in response`)
          }
        })

        this.permissionsLoaded = true
      } catch (error) {
        console.error('Error checking permissions:', error)
      } finally {
        this.$emit('loaded')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/scss/variables.scss';

#home {
  border: none;
}

.app-title {
  color: $k-lime;
  font-size: 1.5em;
  min-width: 5.2em;
}

.ico-container {
  max-width: 750px;
  margin: 3em auto;
  text-align: center;
}

.menu {
  display: block;
  text-transform: uppercase;
  font-family: MuseoSans-700;

  .menu-item {
    width: 150px;
    height: 150px;
    font-size: 1.1em;
    padding: 1em;
    background: $k-lime;
    border-radius: 6%;
    margin: .5em;
    transition: .4s;
    position: relative;
    cursor: pointer;
    vertical-align: top;
    display: inline-block;
    text-align: center;

    &:hover {
      background: $k-turq;
    }

    .wrapper {
      display: table;
      width: 100%;
      height: 100%;

      .menu-name {
        display: table-cell;
        vertical-align: bottom;
      }
    }
  }
}

//for tv
@media screen and (min-width: 2000px) {
  .menu {
    .menu-item {
      width: calc(150px + 6vw);
      height: calc(150px + 6vw);
      font-size: 1.1em;
      padding: 1em;
      margin: .5em;

      .wrapper {
        width: 100%;
        height: 100%;
      }
    }
  }

  .ico-container {
    max-width: calc((150px + 6vw) * 5);
    font-size: .8em;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PageHome.vue